import { useMutation, useQueryClient } from 'react-query';
import { apiWithToken } from '../utils/dispatchRecipe';
import { apiKeys } from '../utils/apiKeys';
import reactQueryKeys from '../queryKeys';

export const useDeleteEnvVar = () => {
  const queryClient = useQueryClient();
  const deleteEnvVar = useMutation((payload: {
    name: string
  }) => apiWithToken({
    url: apiKeys['delete.environment.variables'],
    method: 'POST',
    payload
  }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([reactQueryKeys.envVarsList]);
      }
    }
  );
  return { deleteEnv: deleteEnvVar.mutateAsync, isLoading: deleteEnvVar.isLoading }
};
